import { render } from "./CookiesNormaInput.vue?vue&type=template&id=286ce5a8"
import script from "./CookiesNormaInput.vue?vue&type=script&lang=js"
export * from "./CookiesNormaInput.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\khale\\OneDrive\\Cookies BIS\\CookiesBIS\\core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__